export default __webpack_public_path__ + "static/media/oneMatch.33f1504b.png";